// Environment configuration
const config = {
  baseApi: process.env.REACT_APP_BASE_URL || 'https://api.vedify.app',
  
  env: process.env.REACT_APP_ENV || 'development',
};

export default config;

